import { VscLock } from "react-icons/vsc";
import styled from "styled-components";

import Spacer, { Axis } from "~/components/Spacer";

const LockIcon = styled(VscLock).attrs(() => ({
  width: "14",
  height: "14",
}))`
  font-size: 14px;
  outline: none;
  cursor: pointer;
`;

const EncryptedDotsSVG = (
  <svg width="108" height="36" viewBox="0 0 108 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2" cy="18" r="2" fill="black" />
    <circle cx="10" cy="18" r="2" fill="black" />
    <circle cx="18" cy="18" r="2" fill="black" />
    <circle cx="26" cy="18" r="2" fill="black" />
    <circle cx="34" cy="18" r="2" fill="black" />
    <circle cx="42" cy="18" r="2" fill="black" />
    <circle cx="50" cy="18" r="2" fill="black" />
    <circle cx="58" cy="18" r="2" fill="black" />
    <circle cx="66" cy="18" r="2" fill="black" />
    <circle cx="74" cy="18" r="2" fill="black" />
    <circle cx="82" cy="18" r="2" fill="black" />
    <circle cx="90" cy="18" r="2" fill="black" />
    <circle cx="98" cy="18" r="2" fill="black" />
    <circle cx="106" cy="18" r="2" fill="black" />
  </svg>
);

export function EncryptedValue() {
  return (
    <div style={{ display: "flex", alignItems: "center", height: "36px", padding: "12px" }}>
      <div>
        <LockIcon />
      </div>
      <Spacer axis={Axis.HORIZONTAL} size={10} />
      <div>{EncryptedDotsSVG}</div>
    </div>
  );
}
